<template>
  <div class="space-y-16">
    <h2 class="heading-3">
      {{ i18n(translations.deliveryTitle) }}
    </h2>

    <RevCard v-for="item in items" :key="item.listingId" class="p-24">
      <DeliveredItem :item />

      <div v-for="option in item.options" :key="option.type">
        <ShippingOptions
          :last-collection-point
          :listing-id="item.listingId"
          :option
          :show-collection-point-error="showError"
          @select="selectOption"
        />
      </div>
    </RevCard>
  </div>
</template>

<script lang="ts" setup>
import type { CartItem } from '@backmarket/http-api/src/api-specs-checkout/cart/cart.types'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { decamelizeKeys } from '@backmarket/utils/object/decamelizeKeys'
import { RevCard } from '@ds/components/Card'

import useHandleUnauthorizedUser from '~/scopes/checkout/composables/useHandleUnauthorizedUser'

import translations from './Delivery.translations'
import DeliveredItem from './components/DeliveredItem/DeliveredItem.vue'
import ShippingOptions from './components/ShippingOptions/ShippingOptions.vue'

const emit = defineEmits(['updating', 'updated'])

withDefaults(
  defineProps<{
    items: Array<CartItem>
    showError?: boolean
    lastCollectionPoint?: ApiSpecs['/bm/cart']['GET']['response']['lastCollectionPoint']
  }>(),
  {
    showError: false,
    lastCollectionPoint: undefined,
  },
)

const i18n = useI18n()
const { handleUnauthorizedUser } = useHandleUnauthorizedUser()
const $httpFetch = useHttpFetch()

const selectOption = async (body: {
  listingId: string
  optionType: string
  optionId: string
}) => {
  emit('updating')

  try {
    await $httpFetch('/bm/cart/update_option', {
      method: 'POST',
      body: decamelizeKeys(body),
    })
  } catch (error) {
    await handleUnauthorizedUser(
      error as Record<string, unknown>,
      '[CHECKOUT] Unhandled error updating shipping option',
    )
  } finally {
    emit('updated')
  }
}
</script>
